import React from 'react';
import SectionCard from './SectionCard';

interface StructureSidebarProps {
  sections: any[];
  showTypeSelector: string | null;
  inlineEditingSectionId: string | null;
  editingSectionNameId: string | null;
  editingActivityId: string | null;
  selectedActivityId: string | null;
  newActivity: {
    title: string;
    type: string;
    description: string;
  };
  isSaving: boolean;
  onAddSection: () => void;
  onShowAIAssistant: () => void;
  onShowTypeSelector: (sectionId: string) => void;
  onSelectActivityType: (sectionId: string, type: string) => void;
  onCancelTypeSelector: () => void;
  onCancelInlineActivity: () => void;
  onSaveInlineActivity: (sectionId: string) => void;
  onActivityChange: (activity: any) => void;
  onEditSectionName: (sectionId: string) => void;
  onSaveSectionName: (sectionId: string, newName: string) => void;
  onCancelEditSectionName: () => void;
  onEditActivity: (activityId: string) => void;
  onSaveActivityTitle: (activityId: string, newTitle: string) => void;
  onCancelEditActivity: () => void;
  onDeleteSection: (sectionId: string) => void;
  onDeleteActivity: (activityId: string, sectionId: string) => void;
  onSelectActivity: (activityId: string) => void;
}

const StructureSidebar: React.FC<StructureSidebarProps> = ({
  sections,
  showTypeSelector,
  inlineEditingSectionId,
  editingSectionNameId,
  editingActivityId,
  selectedActivityId,
  newActivity,
  isSaving,
  onAddSection,
  onShowAIAssistant,
  onShowTypeSelector,
  onSelectActivityType,
  onCancelTypeSelector,
  onCancelInlineActivity,
  onSaveInlineActivity,
  onActivityChange,
  onEditSectionName,
  onSaveSectionName,
  onCancelEditSectionName,
  onEditActivity,
  onSaveActivityTitle,
  onCancelEditActivity,
  onDeleteSection,
  onDeleteActivity,
  onSelectActivity
}) => {
  return (
    <div className="w-96 bg-gray-50 border-r border-gray-200 flex flex-col h-full">
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-gray-900">Cấu trúc Module</h3>
          <div className="flex space-x-2">
            <button 
              onClick={onShowAIAssistant}
              disabled={isSaving}
              className={`${
                isSaving ? 'bg-purple-400 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700'
              } text-white px-3 py-1 rounded text-sm font-medium flex items-center`}>
              <svg className="w-4 h-4 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              AI
            </button>
            <button 
              onClick={onAddSection}
              disabled={isSaving}
              className={`${
                isSaving ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
              } text-white px-3 py-1 rounded text-sm font-medium flex items-center`}>
              <svg className="w-4 h-4 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Thêm Section
            </button>
          </div>
        </div>
      </div>
      
      {/* Scrollable Structure Tree */}
      <div className="flex-1 overflow-y-auto p-4">
        <div className="space-y-2">
          {sections?.map((section: any) => (
            <SectionCard
              key={section.section_id}
              section={section}
              showTypeSelector={showTypeSelector}
              inlineEditingSectionId={inlineEditingSectionId}
              editingSectionNameId={editingSectionNameId}
              editingActivityId={editingActivityId}
              selectedActivityId={selectedActivityId}
              newActivity={newActivity}
              isSaving={isSaving}
              onShowTypeSelector={onShowTypeSelector}
              onSelectActivityType={onSelectActivityType}
              onCancelTypeSelector={onCancelTypeSelector}
              onCancelInlineActivity={onCancelInlineActivity}
              onSaveInlineActivity={onSaveInlineActivity}
              onActivityChange={onActivityChange}
              onEditSectionName={onEditSectionName}
              onSaveSectionName={onSaveSectionName}
              onCancelEditSectionName={onCancelEditSectionName}
              onEditActivity={onEditActivity}
              onSaveActivityTitle={onSaveActivityTitle}
              onCancelEditActivity={onCancelEditActivity}
              onDeleteSection={onDeleteSection}
              onDeleteActivity={onDeleteActivity}
              onSelectActivity={onSelectActivity}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StructureSidebar; 